import Header from './Header';
import styled from 'styled-components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Accordion as MAccordion, AccordionDetails } from '@mui/material';

const Wrapper = styled(MAccordion)`
  margin: 0 !important;
  background-color: transparent !important;
  box-shadow: none !important;

  .MuiAccordionDetails-root {
    padding: 0;
  }

  .MuiCollapse-root {
    background-color: #353535;
  }
`

const Accordion = ({ accordions, withExpandIcon, goToCesiumIonPage, goToWebMapServicePage, goToAPIPage }) => {
  const [collapse, setCollapse] = useState()
  const profile = useSelector(state => state.profile.profile);

  const toggleCollapse = newCollapse => {
    if (newCollapse == 'Tips & Tricks') window.open('https://fastmap.readme.io/reference', '_blank');
    setCollapse(collapse !== newCollapse ? newCollapse : null)
  }

  return (accordions.map(({ icon, appendIcon, label, collapsable, Section }, index) => (
    label === "Account Admin" ?
      profile.roles && profile.roles[0] && (profile.roles[0].name == 'Admin' || profile.roles[0].name == 'Manager') ?
        <Wrapper key={index} expanded={collapse === label} onChange={() => toggleCollapse(label)}>
          <Header icon={icon} appendIcon={appendIcon} label={label} editable={collapsable} expanded={collapse === label} withExpandIcon={withExpandIcon} />
          {collapsable && Section && (
            <AccordionDetails>
              <Section goToCesiumIonPage={goToCesiumIonPage} goToWebMapServicePage={goToWebMapServicePage} goToAPIPage={goToAPIPage} />
            </AccordionDetails>
          )}
        </Wrapper>
        :
        null 
      :
      <Wrapper key={index} expanded={collapse === label} onChange={() => toggleCollapse(label)}>
        <Header icon={icon} appendIcon={appendIcon} label={label} editable={collapsable} expanded={collapse === label} withExpandIcon={withExpandIcon} />
        {collapsable && Section && (
          <AccordionDetails>
            <Section goToCesiumIonPage={goToCesiumIonPage} goToWebMapServicePage={goToWebMapServicePage} goToAPIPage={goToAPIPage} />
          </AccordionDetails>
        )}
      </Wrapper>
  )))
}

export default Accordion;